"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestfitOverviewReadyEvent = void 0;
const enums_1 = require("../enums");
class BestfitOverviewReadyEvent {
    constructor(bestfitOverviewApplication) {
        this.bestfitOverviewApplication = bestfitOverviewApplication;
        this.eventType = BestfitOverviewReadyEvent.EventType;
        this.timestamp = new Date();
    }
}
exports.BestfitOverviewReadyEvent = BestfitOverviewReadyEvent;
BestfitOverviewReadyEvent.EventType = enums_1.EventType.BESTFIT_OVERVIEW_READY;
